import { Link } from "react-router-dom";

const platformLinks = [
  { label: "手机版游戏", href: "/#library" },
  { label: "电脑版游戏", href: "/#library" },
  { label: "安卓版游戏", href: "/#library" },
  { label: "汉化版游戏", href: "/#library" },
  { label: "免安装版", href: "/#library" },
];

const guideLinks = [
  { label: "下载指南", href: "/#guide" },
  { label: "常见问题", href: "/#faq" },
  { label: "安装教程", href: "/#guide" },
  { label: "关于我们", href: "/#about" },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white">
                火影同人游戏库
              </span>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-400">
              汇集火影同人游戏下载资源，覆盖手机版、电脑版、安卓、汉化版与免安装版本，为热爱忍者的你提供快捷、清晰的下载指引。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-white">游戏平台</h3>
            <ul className="mt-4 space-y-3">
              {platformLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="inline-flex items-center gap-2 text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-white">帮助中心</h3>
            <ul className="mt-4 space-y-3">
              {guideLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="inline-flex items-center gap-2 text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-white">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <a href="mailto:support@huoying-fan.example" className="hover:text-primary-400">
                  support@huoying-fan.example
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line text-primary-400"></i>
                <span>简体中文</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>每日 9:00 - 22:00 在线</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-foreground-800 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 火影同人游戏库 · 仅整理同人作品下载指引，作品版权归原作者所有
          </p>
          <p className="text-xs text-foreground-500">本站为同人资源信息聚合，非官方站点</p>
        </div>
      </div>
    </footer>
  );
}